<template>
  <div id="app">

  	<van-loading v-if="loading" type="spinner"/>
    <keep-alive>
        <!-- 会被缓存的组件 -->
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不会被缓存的组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data(){
  	return{
  		// loading:false,
  	}
  },
  name: 'App',
  watch:{
    // '$store.state.Loading':(newVal,oldVal)=>{
    //   this.loading=newVal;
    //   this.load=newVal;
    // }
  },
  computed:{
      loading(){
          return this.$store.state.Loading
      }
  },
  mounted(){
  },
  methods:{

  }
}
</script>

<style lang="scss">
	html,body{
		width:100%;
		height:100%;
	}
	#app{
		height:100%;
    width:100%;
    margin:0 auto;
    overflow:auto;
    position: relative;


	}
  .max-content{
    max-width:600px;  
    margin: 0 auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue